// extracted by mini-css-extract-plugin
module.exports = {"parallax":"style_parallax__1Wst6","stars1":"style_stars1__3uxli","animStar":"style_animStar__2DPRD","stars2":"style_stars2__X0tkf","stars3":"style_stars3__JkQdF"};